import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../services/supabaseClient';

export default function ResetPassword() {
  const [nuevaContrasena, setNuevaContrasena] = useState('');
  const [confirmacion, setConfirmacion] = useState('');
  const [mensaje, setMensaje] = useState('');
  const navigate = useNavigate();

  // Restaurar sesión desde el hash de Supabase
  useEffect(() => {
    const hash = window.location.hash;
    if (hash && hash.includes('access_token')) {
      const params = new URLSearchParams(hash.replace('#', ''));
      const access_token = params.get('access_token');
      const refresh_token = params.get('refresh_token');

      if (access_token && refresh_token) {
        supabase.auth.setSession({ access_token, refresh_token })
          .then(({ error }) => {
            if (error) {
              console.error('Error al restaurar sesión:', error.message);
              setMensaje('❌ Error al restaurar sesión.');
            }
          });
      }
    }
  }, []);

  const handleReset = async (e) => {
    e.preventDefault();

    if (nuevaContrasena !== confirmacion) {
      setMensaje('❌ Las contraseñas no coinciden.');
      return;
    }

    const { error } = await supabase.auth.updateUser({
      password: nuevaContrasena,
    });

    if (error) {
      setMensaje('❌ ' + error.message);
    } else {
      setMensaje('✅ Contraseña actualizada correctamente. Redirigiendo...');
      setTimeout(() => navigate('/login'), 2000);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="bg-white shadow-md rounded p-6 w-full max-w-md">
        <h2 className="text-xl font-bold mb-4 text-center text-blue-700">
          Restablecer Contraseña
        </h2>
        <form onSubmit={handleReset} className="space-y-4">
          <input
            type="password"
            placeholder="Nueva contraseña"
            value={nuevaContrasena}
            onChange={(e) => setNuevaContrasena(e.target.value)}
            className="w-full border px-3 py-2 rounded"
            required
          />
          <input
            type="password"
            placeholder="Confirmar contraseña"
            value={confirmacion}
            onChange={(e) => setConfirmacion(e.target.value)}
            className="w-full border px-3 py-2 rounded"
            required
          />
          <button
            type="submit"
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded"
          >
            Restablecer
          </button>
        </form>
        {mensaje && <p className="mt-4 text-center text-sm">{mensaje}</p>}
      </div>
    </div>
  );
}